import { defineMessages } from 'react-intl';

export default defineMessages({
    quoteResults: {
        id: 'ml.gateway.quoteandbind.common.quote.quoteResults',
        defaultMessage: 'Quote Results'
    },
    rename: {
        id: 'ml.gateway.quoteandbind.common.quote.rename',
        defaultMessage: 'Rename'
    },
    perMonth: {
        id: 'ml.gateway.quoteandbind.common.quote.perMonth',
        defaultMessage: 'mo'
    },
    perTermLabelYear: {
        id: 'ml.gateway.quoteandbind.common.quote.perTermLabelYear',
        defaultMessage: 'year'
    },
    perTermLabel6Month: {
        id: 'ml.gateway.quoteandbind.common.quote.perTermLabel6Month',
        defaultMessage: '6 months'
    },
    perTermLabel7day: {
        id: 'ml.gateway.quoteandbind.common.quote.perTermLabel7day',
        defaultMessage: '7 days'
    },
    addQuoteScenario: {
        id: 'ml.gateway.quoteandbind.common.quote.addQuoteScenario',
        defaultMessage: 'ADD QUOTE SCENARIO'
    },
    requoting: {
        id: 'ml.gateway.quoteandbind.common.quote.requoting',
        defaultMessage: 'REQUOTING'
    },
    requote: {
        id: 'ml.gateway.quoteandbind.common.quote.requote',
        defaultMessage: 'REQUOTE'
    },
    continue: {
        id: 'ml.gateway.quoteandbind.common.quote.continue',
        defaultMessage: 'CONTINUE'
    },
    continueToPurchase: {
        id: 'ml.gateway.quoteandbind.common.quote.continueToPurchase',
        defaultMessage: 'CONTINUE TO PURCHASE'
    },
    purchasePolicy: {
        id: 'ml.gateway.quoteandbind.common.quote.purchasePolicy',
        defaultMessage: 'PURCHASE POLICY'
    },
    invalidQuote: {
        id: 'ml.gateway.quoteandbind.common.quote.invalidQuote',
        defaultMessage: 'Invalid Quote Generated'
    },
    invalidQuoteErrorMsg: {
        id: 'ml.gateway.quoteandbind.common.quote.invalidQuoteErrorMsg',
        defaultMessage: 'Sorry, but options picked are not valid, try different option.'
    },
    renameThisQuote: {
        id: 'ml.gateway.quoteandbind.common.quote.renameThisQuote',
        defaultMessage: 'Rename This Quote'
    },
    quoteNameHeader: {
        id: 'ml.gateway.quoteandbind.common.quote.quoteNameHeader',
        defaultMessage: 'Quote Name'
    },
    quoteNameErrorMsg: {
        id: 'ml.gateway.quoteandbind.common.quote.quoteNameErrorMsg',
        defaultMessage: 'Quote name must be 1-60 characters long.'
    },
    saveModalBtn: {
        id: 'ml.gateway.quoteandbind.common.quote.saveModalBtn',
        defaultMessage: 'Save'
    },
    cancelModalBtn: {
        id: 'ml.gateway.quoteandbind.common.quote.cancelModalBtn',
        defaultMessage: 'Cancel'
    },
    policyDiscounts: {
        id: 'ml.gateway.quoteandbind.common.quote.policyDiscounts',
        defaultMessage: 'Policy Discounts'
    },
    numberOfDiscounts: {
        id: 'ml.gateway.quoteandbind.common.quote.numberOfDiscounts',
        defaultMessage: 'NUMBER OF DISCOUNTS'
    },
    viewAll: {
        id: 'ml.gateway.quoteandbind.common.quote.viewAll',
        defaultMessage: 'VIEW ALL'
    },
    collapse: {
        id: 'ml.gateway.quoteandbind.common.quote.collapse',
        defaultMessage: 'COLLAPSE'
    },
    includedFeatures: {
        id: 'ml.gateway.quoteandbind.common.quote.includedFeatures',
        defaultMessage: 'Included Features'
    },
    close: {
        id: 'ml.gateway.quoteandbind.common.quote.close',
        defaultMessage: 'Close'
    },
    priorCarrierPremium: {
        id: 'ml.gateway.quoteandbind.common.quote.priorCarrierPremium',
        defaultMessage: 'Prior Carrier Premium'
    },
    emailAddressRequired: {
        id: 'ml.gateway.quoteandbind.common.quote.emailAddressRequired',
        defaultMessage: 'Email Address Required For Electronic Delivery'
    },
    addEmail: {
        id: 'ml.gateway.quoteandbind.common.quote.addEmail',
        defaultMessage: 'ADD EMAIL'
    },
    updatingAccountContact: {
        id: 'ml.gateway.quoteandbind.common.quote.updatingAccountContact',
        defaultMessage: 'Updating Account Contact...'
    },
    emailAddress: {
        id: 'ml.gateway.quoteandbind.common.quote.emailAddress',
        defaultMessage: 'Email Address'
    },
    yourEmailAddressHere: {
        id: 'ml.gateway.quoteandbind.common.quote.yourEmailAddressHere',
        defaultMessage: 'Your email address here'
    },
    uninsureMotoristLimit: {
        id: 'ml.gateway.quoteandbind.common.quote.uninsureMotoristLimit',
        defaultMessage: 'Please select Uninsured Motorist Limit.'
    },
    autoBoundError: {
        id: 'ml.gateway.quoteandbind.common.quote.autoBoundError',
        defaultMessage: 'An Auto quote must be bound before binding the Umbrella quote'
    },
    error: {
        id: 'ml.gateway.quoteandbind.common.quote.error',
        defaultMessage: 'Error'
    },
    errorUpdatingContact: {
        id: 'ml.gateway.quoteandbind.common.quote.errorUpdatingContact',
        defaultMessage: 'Error Updating Contact'
    },
    suspendedLiability: {
        id: 'ml.gateway.quoteandbind.common.quote.suspendedLiability',
        defaultMessage: '<p><strong>Warning:</strong>  If you suspend liability, the following coverages will also be suspended:  Bodily Injury, Property Damage, Combined Single Limit, Uninsured Motorist, Underinsured Motorist, Uninsured and Underinsured Bodily Injury, Uninsured Property Damage, Personal Injury Protection and Medical coverage.</p><br></br><p>In an accident, the vehicle owner and driver could be held personally liable for any damages.  The vehicle may be considered uninsured and may be subject to penalty under the state’s motor vehicle laws.</p>'
    },
    paNamedExcludeAllSelectedMessage: {
        id: 'ml.gateway.quoteandbind.common.quote.paNamedExcludeAllSelectedMessage',
        defaultMessage: '{vehicleName} - All drivers have been checked for Named Driver Exclusion. Need to uncheck at least one driver or remove Named Driver Exclusion and comprehensive and collision coverages.'
    },
    paNamedExcludeNoneSelectedMessage: {
        id: 'ml.gateway.quoteandbind.common.quote.paNamedExcludeNoneSelectedMessage',
        defaultMessage: '{vehicleName} - Must select a driver to exclude  or remove Named Driver Exclusion.'
    },
    calculatingQuote: {
        id: 'ml.gateway.quoteandbind.common.quote.calculatingQuote',
        defaultMessage: 'Calculating Quote...'
    },
    pupLiabilityLimitsWarning: {
        id: 'ml.gateway.quoteandbind.common.quote.The required minimum liability limits have not been met for Umbrella.',
        defaultMessage: 'The required minimum liability limits have not been met for Umbrella. <a>View minimum limits.</a>'
    },
    requiredMinimumUnderlyingInsurance: {
        id: 'ml.gateway.quoteandbind.common.quote.Required Minimum Underlying Insurance',
        defaultMessage: 'Required Minimum Underlying Insurance'
    },
    creatingCustomQuotes: {
        id: 'ml.gateway.quoteandbind.common.quote.creatingCustomQuotes',
        defaultMessage: 'Creating new offer...'
    },
    ITVAck: {
        id: 'ml.gateway.quoteandbind.common.quote.ITVAck',
        defaultMessage: 'The selected dwelling coverage limit is below the estimated replacement cost for the dwelling.  At this dwelling coverage amount, the insured may not have enough coverage to rebuild their home in the event of a total loss.  By clicking the PURCHASE POLICY button, the insured is acknowledging they do not want to insure their home for the full estimated cost to rebuild.'
    },
    functionalReplacementCostWarning: {
        id: 'ml.gateway.quoteandbind.common.quote.Building Property Loss Settlement option...',
        defaultMessage: 'Building Property Loss Settlement option is not valid as both Guaranteed and Functional have been selected. Changes are required to either the Property Details or Coverages.'
    },
    akAutoFullTermWarningAlertPCSIA: {
        id: 'ml.gateway.quoteandbind.common.quote.To quote an Alaska 7 Day policy, contact us at 1-800-255-0332 for assistance.',
        defaultMessage: 'To quote an Alaska 7 Day policy, contact us at 1-800-255-0332 for assistance.'
    },
    akAutoFullTermWarningAlert: {
        id: 'ml.gateway.quoteandbind.common.quote.To quote an Alaska 7 Day policy, quote must be done in PolicyCenter.',
        defaultMessage: 'To quote an Alaska 7 Day policy, quote must be done in PolicyCenter.'
    },
    ak7DayWarningAlertPCSIA: {
        id: 'ml.gateway.quoteandbind.common.quote.Quote is available as view only.  Contact us at 1-800-255-0332 for assistance.',
        defaultMessage: 'Quote is available as view only.  Contact us at 1-800-255-0332 for assistance.'
    },
    ak7DayWarningAlert: {
        id: 'ml.gateway.quoteandbind.common.quote.Quote is available as view only.  All changes must be completed in PolicyCenter.',
        defaultMessage: 'Quote is available as view only.  All changes must be completed in PolicyCenter.'
    },
    bookrollWarningAlert: {
        id: 'ml.gateway.quoteandbind.common.quoteQuote is available as view only. Please contact your Book Consolidation manager for assistance.',
        defaultMessage: 'Quote is available as view only. Please contact your Book Consolidation manager for assistance.'
    },
    compareNowBtn: {
        id: 'ml.gateway.quoteandbind.common.quote.COMPARE NOW',
        defaultMessage: 'COMPARE NOW'
    },
    compareVersionBtn: {
        id: 'ml.gateway.quoteandbind.common.quote.COMPARE VERSIONS',
        defaultMessage: 'COMPARE VERSIONS'
    },
    exportingQuote: {
        id: 'ml.gateway.quoteandbind.common.quote.Exporting quote...',
        defaultMessage: 'Exporting quote...'
    },
    syncAgentChoice: {
        id: 'ml.gateway.quoteandbind.common.quote.Sync Agent Choice...',
        defaultMessage: 'Sync Agent Choice...'
    },
    compareNowUnavailable: {
        id: 'ml.gateway.quoteandbind.common.quote.Compare Now Unavailable',
        defaultMessage: 'Compare Now Unavailable'
    },
    compareNowUnavailableAtThisTime: {
        id: 'ml.gateway.quoteandbind.common.quote.Compare Now function is unavailable at this time',
        defaultMessage: 'Compare Now function is unavailable at this time'
    },
    closeBtn: {
        id: 'ml.gateway.quoteandbind.common.quote.CLOSE',
        defaultMessage: 'CLOSE'
    },
    windstormHailDeductibleBumpedWarning: {
        id: 'ml.gateway.quoteandbind.common.quote.WindstormHailDeductibleBumped',
        defaultMessage: 'The Windstorm or Hail Deductible was updated to the minimum required deductible.'
    },
    roofLossSettlementBumpedWarning: {
        id: 'ml.gateway.quoteandbind.common.quote.roofLossSettlementBumped',
        defaultMessage: 'Roof Loss Settlement was updated to Scheduled Roof as required.'
    },
    premiumChangedAfterVehicleMvrWarning: {
        id: 'ml.gateway.quoteandbind.common.quote.premiumChangedWarning',
        defaultMessage: 'The previously quoted premium has changed due to the entry of additional information.'
    },
    allOtherPerilBumpedWarning: {
        id: 'ml.gateway.quoteandbind.common.quote.AllOtherPerilBumped',
        defaultMessage: 'The All Other Perils deductible was updated to the minimum required deductible.'
    },
    grcAvailableBumpedWarning: {
        id: 'ml.gateway.quoteandbind.common.quote.GRCAvailableBumped',
        defaultMessage: 'Blanket Property and/or Guaranteed Rebuild is not available for this risk and the Building Property Loss Settlement and building code coverage have been updated.'
    },
    somethingWentWrong: {
        id: 'ml.gateway.quoteandbind.common.quote.somethingWentWrong',
        defaultMessage: 'Something went wrong during this process. Please try again.'
    },
    maritalStatusRelationshipWarning: {
        id: 'ml.gateway.quoteandbind.common.quote.maritalStatusRelationshipWarning',
        defaultMessage: "Relationship mismatch: only single driver(s) present with relationship to insured as 'Spouse/Co-Insured'. Please review and confirm Marital Status before proceeding"
    },
    mvrErrorMessage: {
        id: 'ml.gateway.quoteandbind.common.quote.mvrErrorMessage',
        defaultMessage: 'Motor Vehicle Record not available at this time, please try again later.'
    },
    pupUnderlyingPoliciesSynched: {
        id: 'ml.gateway.quoteandbind.common.quote.pupUnderlyingPoliciesSynched',
        defaultMessage: 'Informational Message: The underlying policy information has been refreshed and may have changed any exclusions that were selected on the quote. Please review to make sure all information is accurate.'
    },
    producerCodechangedWarning: {
        id: 'ml.gateway.quoteandbind.common.quote.producerCodechangedWarning',
        defaultMessage: 'This producer does not have an active license, appointment, or state authority for this quote. To continue, we have automatically updated the producer code to the primary group producer. If you are a non-licensed (NL) user or would like to be appointed, please contact Agency Contract Management at 1-800-237-6136 for assistance. '
    },
    producerCodechanged: {
        id: 'ml.gateway.quoteandbind.common.quote.producerCodechanged',
        defaultMessage: 'The selected producer code is not eligible for this quote. To continue, we have automatically changed the producer code to the agencys Primary Group Producer Code. '
    },
    producerCodeAcknowledgementTitle: {
        id: 'ml.gateway.quoteandbind.common.quote.producerCodeAcknowledgementTitle',
        defaultMessage: 'Producer Code Updated'
    },
    producerCodechangedAdditionalText: {
        id: 'ml.gateway.quoteandbind.common.quote.producerCodechangedAdditionalText',
        defaultMessage: 'Select Continue to proceed or Cancel to choose a different producer code.'
    },
    producerCodechangedAssistanceText: {
        id: 'ml.gateway.quoteandbind.common.quote.producerCodechangedAssistanceText',
        defaultMessage: 'For assistance, contact Agency Contract Management at 1-800-237-6136.'
    },
    acknowledgeAndContinue: {
        id: 'ml.gateway.quoteandbind.common.quote.acknowledgeAndContinue',
        defaultMessage: 'ACKNOWLEDGE AND CONTINUE'
    }
});
